module.exports = __webpack_public_path__ + "img/default-banner.303f4548.png";